
export function isHubApp() {
  return typeof window !== 'undefined' && typeof window.FlutterHub !== 'undefined';
}

export default isHubApp;
